<template>
  <div class="gm-admin-tab">
    <div class="gm-admin-tab__head">
      <div>
        <h2>{{ $t('frontend_groovemail_admin_settings_transactional_mail_settings') }}</h2>
        <p class="gm-admin-tab__hint">{{ $t('frontend_groovemail_admin_configure_settings') }}</p>
      </div>
      <gs-button variant="primary" @click="updateTransactionMailSetting()">{{ $t('frontend_save') }}</gs-button>
    </div>

    <div class="gm-admin-tab__row">
      <gs-field
        :label="`${$t('frontend_groovemail_settings_transactional_mail_settings_percentage_text')}“${$t('frontend_groovemail_settings_transactional_mail_settings_warmup_pool')}”`"
      >
        <div class="gm-admin-tab__suffix">
          <text-input
            variant="base"
            v-model="model.warmupPoolPercent"
            @input="warmUpDataUpdated"
            :placeholder="$t('frontend_groovemail_settings_transactional_mail_settings_enter_percent')"
            :validator="$v.model.warmupPoolPercent"
          />
          <span>%</span>
        </div>
      </gs-field>
      <gs-field
        :label="`${$t('frontend_groovemail_settings_transactional_mail_settings_percentage_text')}“${$t('frontend_groovemail_settings_transactional_mail_settings_recovery_pool')}”`"
      >
        <div class="gm-admin-tab__suffix">
          <text-input
            variant="base"
            v-model="model.recoveryPoolPercent"
            @input="recoveryDataUpdated"
            :placeholder="$t('frontend_groovemail_settings_transactional_mail_settings_enter_percent')"
            :validator="$v.model.recoveryPoolPercent"
          />
          <span>%</span>
        </div>
      </gs-field>
    </div>
  </div>
</template>

<script>
import { required, numeric, between } from 'vuelidate/lib/validators';
import { adminUrls } from '@/utils/urls.js';
import { getData, postData } from '@/utils/apiHelper.js';
import { showErrorDialog } from '@/components/showDialog.js';

export default {
  data() {
    return {
      model: {
        warmupPoolPercent: 0,
        recoveryPoolPercent: 0,
      },
      transactionSettingsChanged: false,
    };
  },

  validations: {
    model: {
      warmupPoolPercent: {
        required,
        numeric,
        between: between(0, 100),
      },
      recoveryPoolPercent: {
        required,
        numeric,
        between: between(0, 100),
      },
    },
  },

  // Initializes data properties with transaction mail data.
  async created() {
    await this.initializeTransactionMailData();
  },
  methods: {
	  // Triggered on change of warm-up pool percentage
    warmUpDataUpdated() {
      this.updateTransactionSettingsChange(true);
      this.model.recoveryPoolPercent = 100 - this.model.warmupPoolPercent;
    },

    // Triggered on change of recovery pool percentage
    recoveryDataUpdated() {
      this.updateTransactionSettingsChange(true);
      this.model.warmupPoolPercent = 100 - this.model.recoveryPoolPercent;
    },

    // Used to update change in transactional settings
    updateTransactionSettingsChange(settingsChanged) {
      this.transactionSettingsChanged = settingsChanged;
    },
    
    // Fetches transaction mail data and initializes them to data properties.
    async initializeTransactionMailData() {
	    const transactionMailData = await getData(
        adminUrls.mainSettingsUrl.fetchTransactionMailSettings
      );
      this.model.warmupPoolPercent =
        transactionMailData &&
        transactionMailData.data &&
        transactionMailData.data['warmup-percentage']
          ? transactionMailData.data['warmup-percentage']
          : 0;
      this.model.recoveryPoolPercent =
        transactionMailData &&
        transactionMailData.data &&
        transactionMailData.data['recovery-percentage']
          ? transactionMailData.data['recovery-percentage']
          : 0;
    },

    // Saves transaction mail data.
    async updateTransactionMailSetting() {
      let validity = true;
      this.$v.model.warmupPoolPercent.$touch();
      this.$v.model.recoveryPoolPercent.$touch();
      validity = !(
        this.$v.model.warmupPoolPercent.$invalid ||
        this.$v.model.recoveryPoolPercent.$invalid
      );

      if (this.transactionSettingsChanged) {
        if (validity) {
	        await postData(
            adminUrls.mainSettingsUrl.updateTransactionMailSettings,
            {
              warmup_percentage: this.model.warmupPoolPercent,
              recovery_percentage: this.model.recoveryPoolPercent,
            }
          );
          this.updateTransactionSettingsChange(false);
        }
      } else {
	        await showErrorDialog('', this.$t('frontend_groovemail_admin_transactional_mail_settings_update_warning'));        
      }
    },
  },
};
</script>

